import Vue from 'vue'
import Router from 'vue-router'
import AuthenticationService from '@/services/authentication'

import AuthCallback from '@/views/AuthCallback.vue'

const Overview = () => import(/* webpackChunkName: "overview" */ '@/views/Overview.vue')
const Start = () => import(/* webpackChunkName: "start" */ '@/views/Start.vue')
const Topology = () => import(/* webpackChunkName: "topology" */ '@/views/Topology.vue')
const GeoMap = () => import(/* webpackChunkName: "geomap" */ '@/views/GeoMap.vue')
const Tokens = () => import(/* webpackChunkName: "tokens" */ '@/views/Tokens.vue')
const Integrations = () => import(/* webpackChunkName: "integrations" */ '@/views/Integrations.vue')

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_PATH || '/',
  routes: [
    {
      path: '/callback',
      name: 'callback',
      component: AuthCallback
    },
    {
      path: '/overview',
      name: 'Overview',
      component: Overview
    },
    {
      path: '/start',
      name: 'Start',
      component: Start
    },
    {
      path: '/topology',
      name: 'Topology',
      component: Topology
    },
    {
      path: '/geomap',
      name: 'GeoMap',
      component: GeoMap
    },
    {
      path: '/tokens',
      name: 'Tokens',
      component: Tokens
    },
    {
      path: '/integrations',
      name: 'Integrations',
      component: Integrations
    },
    {
      path: '/',
      redirect: '/start'
    },
    {
      path: '*',
      redirect: '/start'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path === '/callback' || AuthenticationService.isAuthenticated()) {
    return next()
  }

  // Specify the current path as the customState parameter, meaning it
  // will be returned to the application after auth
  AuthenticationService.login(JSON.stringify({
    base: process.env.VUE_APP_BASE_PATH || '/',
    path: to.path
  }))
})

export default router
